// @flow
import * as React from 'react';
import clsx from 'clsx';
type Props = {
  items: {
    label: JSX.Element | string;
    value: string;
    labelClassName?: string;
    valueClassName?: string;
    itemClassName?: string;
  }[];
  className?: string;
};

export const LabelCard = (props: Props) => {
  return (
    <div className={clsx('bg-neutral-98 rounded-xl p-4   ', props.className)}>
      {props.items?.map((item, index) => {
        return (
          <div
            key={index}
            className={clsx(
              item.itemClassName
                ? item.itemClassName
                : 'mb-4 flex justify-between items-center text-base ',
            )}
          >
            <div
              className={clsx(
                item.labelClassName
                  ? item.labelClassName
                  : 'text-neutral-50 mr-6 ',
              )}
            >
              {item.label}
            </div>
            <div
              className={clsx(
                item.valueClassName ? item.valueClassName : 'text-neutral-12',
              )}
            >
              {item.value}
            </div>
          </div>
        );
      })}
    </div>
  );
};
